import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'blogPostTags'
})
export class BlogPostTagsPipe implements PipeTransform {
  transform(value: string[]): string {
    const processedTags = value?.sort().join(", ");

    return processedTags;
  }
}
